import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileToolManagementService {

  constructor(private readonly http: HttpClient) { }


  setToolCredentials(model: any): any {
    return this.http.post(
      `${environment.apiUrl}/ProfileToolManagement/SetToolCredentials`,
      model
    );
  }

  listMyTools(params: any): any {
    return this.http.get(
      `${environment.apiUrl}/ProfileToolManagement/ListMyTools`,
      { params }
    );
  }

  validateMainCredentials(model: any): any {
    return this.http.post(
      `${environment.apiUrl}/ProfileToolManagement/ValidateMainCredentials`,
      model
    );
  }
  validateADEnvironmentCredentials(model: any): any {
    return this.http.post(
      `${environment.apiUrl}/ProfileToolManagement/ValidateADEnvironmentCredentials`,
      model
    );
  }

  checkCredentials(model: any): any {
    return this.http.post(
      `${environment.apiUrl}/ProfileToolManagement/CheckCredentials`,
      model
    );
  }

  getAdEnvironmentsCredentials(params: any): any {
    return this.http.get(
      `${environment.apiUrl}/ProfileToolManagement/GetAdEnvironmentsCredentials`,
      { params }
    );
  }

  resetToolCredentials(params: any): any {
    return this.http.delete(
      `${environment.apiUrl}/ProfileToolManagement/ResetToolCredentials`,
      { params }
    );
  }

}
